import { merchantApi } from '@/config/axios'

/** Tab：PENDING/PROCESSING/COMPLETED/REFUNDING */
export type O2oOrderMerchantTab = 'PENDING' | 'PROCESSING' | 'COMPLETED' | 'REFUNDING'

export interface O2oOrderMerchantPageReqVO {
  pageNo: number
  pageSize: number
  tab?: O2oOrderMerchantTab
  no?: string
  createTime?: string[]
}

export interface O2oOrderMerchantRespVO {
  id: number
  no: string
  status: number
  fulfillmentType?: string
  payPrice: number
  refundStatus?: number
  refunding?: boolean
  createTime?: string
  slaTimeout?: boolean
  serviceName?: string
  providerId?: number
  providerName?: string
  appointmentDate?: string
  appointmentTime?: string
  contactName?: string
  contactPhone?: string
  serviceAddress?: string
  providerRejected?: boolean
  availableActions?: string[]
}

export interface O2oOrderMerchantItemVO {
  id: number
  spuName: string
  picUrl?: string
  count: number
  payPrice: number
}

export interface O2oOrderMerchantDetailVO {
  id: number
  no: string
  status: number
  fulfillmentType?: string
  payPrice: number
  refundStatus?: number
  refundPrice?: number
  refunding?: boolean
  createTime?: string
  payTime?: string
  remark?: string
  providerId?: number
  providerName?: string
  institutionName?: string
  appointmentDate?: string
  appointmentTime?: string
  contactName?: string
  contactPhone?: string
  serviceAddress?: string
  reservationStatus?: string
  reservationRemark?: string
  items?: O2oOrderMerchantItemVO[]
  availableActions?: string[]
  orderImages?: string[]
  providerServiceImages?: string[]
}

export interface O2oOrderDispatchVO {
  id: number
  orderId: number
  orderNo?: string
  dispatchType?: string
  targetType?: string
  targetId?: number
  targetName?: string
  status?: string
  timeoutAt?: string
  createTime?: string
}

export function getO2oMerchantOrderPage(params: O2oOrderMerchantPageReqVO) {
  return merchantApi.get<{ list: O2oOrderMerchantRespVO[]; total: number }>({
    url: '/merchant-api/o2o/order/page',
    params
  })
}

export function getO2oMerchantOrder(id: number) {
  return merchantApi.get<O2oOrderMerchantDetailVO>({
    url: '/merchant-api/o2o/order/get',
    params: { id }
  })
}

export interface O2oOrderAssignableProviderVO {
  id: number
  realName: string
  mobile?: string
  status?: string
  acceptingOrders?: boolean
}

export function getO2oMerchantAssignableProviders(orderId: number) {
  return merchantApi.get<O2oOrderAssignableProviderVO[]>({
    url: '/merchant-api/o2o/order/assignable-providers', params: { orderId }
  })
}

export function assignO2oMerchantOrder(data: { orderId: number; providerId: number }) {
  return merchantApi.put<boolean>({
    url: '/merchant-api/o2o/order/assign',
    data,
    headers: { 'X-Idempotency-Key': `assign-${data.orderId}-${Date.now()}` }
  })
}

export function returnO2oMerchantOrderToPlatform(data: { orderId: number; reason?: string }) {
  return merchantApi.put<boolean>({
    url: '/merchant-api/o2o/order/return-platform',
    data,
    headers: { 'X-Idempotency-Key': `return-platform-${data.orderId}-${Date.now()}` }
  })
}

export function getO2oMerchantOrderDispatchList(orderId: number) {
  return merchantApi.get<O2oOrderDispatchVO[]>({
    url: '/merchant-api/o2o/order/dispatch-list',
    params: { orderId }
  })
}
